<template>
  <div class="main-page page-jd-people ">
    <Menu title="司法鉴定人员查询" :home="true">
      <template slot="left-link">
        <a href="javascript:;" @click="goPrevious"></a>
      </template>
    </Menu>
    <div class="container-flex">
      <div class="jd-content  " v-if="step==1">

        <div class="input-panel">
          <input type="text" @focus="setTxtArea" v-model="searchForm.keyword" placeholder="请输入司法鉴定人员姓名/执业证号">
          <button @click="getSearch"> <img src="https://qiniu.laway.cn/yn/2025/02/08/f8648f40e5c411ef99f8b4055d0b07be.svg"> 搜索</button>
        </div>
        <div class="search-params  ">
          <div class="hts">高级检索</div>
          <div class="params-item">
            <div class="params-item-title">所在地区：</div>
            <div class="params-item-content">
              <div @click="searchForm.city=''" :class="['radio-item  ',{active:!searchForm.city}]">
                <input type="radio">
                不限
              </div>
              <div @click="searchForm.city = key" :class="['radio-item  ',{active:searchForm.city==key}]" v-for="(city, key) in arealist" :key="'key-c' + key">
                <input type="radio" v-model="searchForm.code">
                {{city.alias}}
              </div>
            </div>
          </div>
          <div class="params-item" v-if="arealist[searchForm.city]">
            <div class="params-item-title">所在区县：</div>
            <div class="params-item-content">
              <div @click="searchForm.code=''" :class="['radio-item  ',{active:!searchForm.code}]">
                <input type="radio" v-model="searchForm.code">
                不限
              </div>
              <div @click="searchForm.code = key" :class="['radio-item  ',{active:searchForm.code==key}]" v-for="(v, key) in arealist[searchForm.city].children" :key="'key-c' + key">
                <input type="radio" v-model="searchForm.code">
                {{v.alias}}
              </div>
            </div>
          </div>

          <div class="params-item">
            <div class="params-item-title">执业类别：</div>
            <div class="params-item-content">
              <div @click="setClearBusinessAll" :class="['radio-item ',{active:!searchForm.business_type1}]">
                <input type="radio" value="">
                不限
              </div>
              <div @click="searchForm.business_type1=v.id" v-for="(v, key) in identifytree" :key="'key-c' + key" :class="['radio-item ',{active:searchForm.business_type1==v.id}]">
                <input type="radio" :value="v.id">
                {{ v.name }}
              </div>

            </div>
          </div>
          <div class="params-item" v-if="secondArr.length">
            <div class="params-item-title">执业类别：</div>
            <div class="params-item-content">
              <div @click="searchForm.business_type2 = '';searchForm.business_type3 = ''" :class="['radio-item ',{active:!searchForm.business_type2}]">
                <input type="radio" value="">
                不限
              </div>
              <div @click="searchForm.business_type2=v.id" v-for="(v, key) in secondArr" :key="'key-c' + key" :class="['radio-item ',{active:searchForm.business_type2==v.id}]">
                <input type="radio" :value="v.id">
                {{ v.name }}
              </div>

            </div>
          </div>
          <div class="params-item" v-if="thirdArr.length">
            <div class="params-item-title">执业类别：</div>
            <div class="params-item-content">
              <div @click="searchForm.business_type3 = ''" :class="['radio-item ',{active:!searchForm.business_type3}]">
                <input type="radio" value="">
                不限
              </div>
              <div @click="searchForm.business_type3=v.id" v-for="(v, key) in thirdArr" :key="'key-c' + key" :class="['radio-item ',{active:searchForm.business_type3==v.id}]">
                <input type="radio" :value="v.id">
                {{ v.name }}
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="search-content" v-if="step==2">
        <div class="jd-search-panel  ">

          <div class="input-panel">
            <input type="text" v-model="searchForm.keyword" placeholder="中文姓名/执业证号">
            <button class="flex justify-center items-center flex-shrink-0 text-lg" @click="getSearch"> <img src="https://qiniu.laway.cn/yn/2025/02/08/f8648f40e5c411ef99f8b4055d0b07be.svg" class="mr-[4px]"> 搜索</button>
          </div>
          <div class="search-params  ">
            <div class="hts">高级检索</div>
            <div class="params-item">
              <div class="params-item-title">所在地区：</div>
              <div class="params-item-content">
                <div @click="searchForm.city=''" :class="['radio-item  ',{active:!searchForm.city}]">
                  <input type="radio">
                  不限
                </div>
                <div @click="searchForm.city = key" :class="['radio-item  ',{active:searchForm.city==key}]" v-for="(city, key) in arealist" :key="'key-c' + key">
                  <input type="radio" v-model="searchForm.code">
                  {{city.alias}}
                </div>
              </div>
            </div>
            <div class="params-item" v-if="arealist[searchForm.city]">
              <div class="params-item-title">所在区县：</div>
              <div class="params-item-content">
                <div @click="searchForm.code=''" :class="['radio-item  ',{active:!searchForm.code}]">
                  <input type="radio" v-model="searchForm.code">
                  不限
                </div>
                <div @click="searchForm.code = key" :class="['radio-item  ',{active:searchForm.code==key}]" v-for="(v, key) in arealist[searchForm.city].children" :key="'key-c' + key">
                  <input type="radio" v-model="searchForm.code">
                  {{v.alias}}
                </div>
              </div>
            </div>

            <div class="params-item">
              <div class="params-item-title">执业类别：</div>
              <div class="params-item-content">
                <div @click="setClearBusinessAll" :class="['radio-item ',{active:!searchForm.business_type1}]">
                  <input type="radio" value="">
                  不限
                </div>
                <div @click="searchForm.business_type1=v.id" v-for="(v, key) in identifytree" :key="'key-c' + key" :class="['radio-item ',{active:searchForm.business_type1==v.id}]">
                  <input type="radio" :value="v.id">
                  {{ v.name }}
                </div>

              </div>
            </div>
            <div class="params-item" v-if="secondArr.length">
              <div class="params-item-title">执业类别：</div>
              <div class="params-item-content">
                <div @click="searchForm.business_type2 = '';searchForm.business_type3 = ''" :class="['radio-item ',{active:!searchForm.business_type2}]">
                  <input type="radio" value="">
                  不限
                </div>
                <div @click="searchForm.business_type2=v.id" v-for="(v, key) in secondArr" :key="'key-c' + key" :class="['radio-item ',{active:searchForm.business_type2==v.id}]">
                  <input type="radio" :value="v.id">
                  {{ v.name }}
                </div>

              </div>
            </div>
            <div class="params-item" v-if="thirdArr.length">
              <div class="params-item-title">执业类别：</div>
              <div class="params-item-content">
                <div @click="searchForm.business_type3 = ''" :class="['radio-item ',{active:!searchForm.business_type3}]">
                  <input type="radio" value="">
                  不限
                </div>
                <div @click="searchForm.business_type3=v.id" v-for="(v, key) in thirdArr" :key="'key-c' + key" :class="['radio-item ',{active:searchForm.business_type3==v.id}]">
                  <input type="radio" :value="v.id">
                  {{ v.name }}
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="p-list-panel">

          <div class="p-list ">
            <div class="item" v-for="(item, index) in list" :key="'res'+ index" @click="previewPeople(item)">
              <img :src="item.photo ||'/img/ui/lawyer_avatar.png'" alt="">

              <div class="content">
                <div class="name">
                  {{item.name}}
                </div>
                <div>
                  所在机构：{{ item.org_name }}
                </div>
                <div class="skill">
                  执业证号：{{ item.no }}
                </div>
                <div>
                  技术职称：{{ item.title || '无' }}
                </div>
              </div>

            </div>

            <div v-if="loadOver&& !list.length" class="empty-info">
              <img src="https://qiniu.laway.cn/yn/2020/11/10/e0a5a0ac22fe11eb8cd1b4055d0b07be.png" class="mx-auto" alt="">
              <p>没有搜索到~</p>
            </div>
          </div>

        </div>
      </div>
    </div>
    <org-people :currentstaff="currentstaff" orgtype="1" :showStaff="showStaff" @close="showStaff = false" />

  </div>
</template>
<script>
import Menu from '@/components/Menu'
import OrgPeople from '@/components/org-people-dialog.vue'
export default {
  components: { Menu, OrgPeople },
  data () {
    return {
      identifytree: [],
      showStaff: false,
      currentstaff: '',
      searchForm: {
        city: '',
        code: '',
        keyword: '',
        business_type1: '',
        business_type2: '',
        business_type3: '',
      },
      list: [],
      loadOver: false,
      step: 1,
      currentstaff: false,
      showStaff: false
    }
  },
  computed: {
    arealist () {
      return this.$store.state.device.area
    },
    secondArr () {
      const item = this.identifytree.find(v => {
        return v.id === this.searchForm.business_type1
      })
      return (item && item.children) || []
    },
    thirdArr () {
      const item = this.secondArr.find(v => {
        return v.id === this.searchForm.business_type2
      })
      return (item && item.children) || []
    }
  },

  created () {
    this.getTreeData()
  },

  methods: {
    setTxtArea () {
      window.addEventListener('resize', function () {
        if (document.activeElement.tagName === 'TEXTAREA' || document.activeElement.tagName === 'INPUT') {
          document.activeElement.scrollIntoView({ behavior: 'smooth' })
        }
      })
    },
    async getTreeData () {
      const result = await this.$api.getIdentifyTree()
      if (!result) return
      this.identifytree = result.data
    },
    setClearBusinessAll () {
      this.searchForm.business_type1 = ''
      this.searchForm.business_type2 = ''
      this.searchForm.business_type3 = ''
    },
    getSearch () {
      let { keyword } = this.searchForm;
      if (keyword.length < 2) {
        this.$alert(keyword.length ? '至少输入两位关键字' : '请输入司法鉴定人员姓名/执业证号')
        return
      }
      this.loadOver = false
      this.getList()

    },
    async getList () {
      let { keyword, city, code } = this.searchForm;
      let result = await this.$api.getOrganizationEmployee({
        code: code || city,
        keyword,
        business_type: this.searchForm.business_type3 || this.searchForm.business_type2 || this.searchForm.business_type1,
        org_type: 1,
        per_page: 100,
        page: this.page
      })
      console.log(result, 'items')
      if (!result.status) return
      this.list = result.items || []
      this.loadOver = true
      this.step = 2
    },
    goPrevious () {
      if (this.step === 1) {
        this.$router.go(-1)
      } else {
        this.step--
      }
    },

    previewPeople (item) {
      this.currentstaff = item
      this.showStaff = true
    }
  }
}
</script>
<style lang="stylus" scoped>
.page-jd-people
  color #fff
  .jd-content
    width 70%
    margin 0 auto
    padding-top 0.7rem
    .tab-nav
      padding-left 0.3rem
      font-size 0.26rem
      .nav-item
        margin-right 38px
        color #ffffff
        text-decoration none
        &.active
          color #ffc419
    .input-panel
      position relative
      margin-top 0.1rem
      border-radius 0.1rem
      display flex
      background #fff
      border 1px solid #378bf8
      &.c1::before, &.c2::before
        content ''
        position absolute
        top -7px
        width 0
        height 0
        z-index 2
        border-style solid
        border-width 0 7px 7px 7px
        border-color transparent transparent #fff transparent
      &.c1::before
        left 0.4rem
      &.c2::before
        left 1.4rem
      input
        color #333
        font-size 0.22rem
        padding 0 0.2rem
        flex 1
        border-radius 0.1rem 0 0 0.1rem
        border 0
      input:-moz-placeholder, input::-moz-placeholder
        color #999
        opacity 1
      input:-ms-input-placeholder
        color #999
      input::-webkit-input-placeholder
        color #999
      button
        border-radius 0.1rem
        width 3.6rem
        height 0.72rem
        margin 0.04rem
        background-color #2a69e0
    .search-params
      padding-top 0.6rem
      padding-bottom 2rem
      .hts
        font-size 0.24rem
        letter-spacing 1px
        color #ffffff
        margin-bottom 0.4rem
      .params-item
        display flex
        margin-bottom 0.3rem
        .params-item-title
          font-size 0.22rem
          width 1.1rem
          flex-shrink 0
          text-align right
        .params-item-content
          flex 1
          display flex
          font-size 0.22rem
          flex-wrap wrap
          padding-left 0.1rem
    .radio-item
      letter-spacing 2px
      margin-bottom 0.1rem
      margin-right 0.2rem
      input
        width 12px
        height 12px
        cursor pointer
        margin-right 2px
        border-radius 2px
        border solid 1px #fff
      &.active
        color #f29530
        input
          position relative
          border-color #f29530
          &::after
            content ''
            position absolute
            top -1px
            left 1px
            width 5px
            height 8px
            border-left solid #f29530 1px
            border-top solid #f29530 1px
            transform rotate(225deg)
  .search-content
    display flex
    overflow hidden
    height 100%
    color #333
    .jd-search-panel
      width 25%
      padding 0.2rem
      background #fff
      height 100%
      .input-panel
        position relative
        margin-top 0.1rem
        border-radius 0.1rem
        overflow hidden
        display flex
        background #fff
        border 1px solid #378bf8
        input
          font-size 0.18rem
          padding 0 0.2rem
          flex 1
          border 0
        input:-moz-placeholder, input::-moz-placeholder
          color #999
          opacity 1
        input:-ms-input-placeholder
          color #999
        input::-webkit-input-placeholder
          color #999
        button
          width 1rem
          height 0.45rem
          font-size 0.2rem
          color #fff
          background-color #2a69e0
      .search-params
        padding-top 0.2rem
        .hts
          font-size 0.2rem
          font-weight bold
          letter-spacing 1px
          color #333
          margin-bottom 0.1rem
        .params-item
          display flex
          align-items baseline
          margin-bottom 0.1rem
          .params-item-title
            font-size 0.18rem
            width 0.9rem
            flex-shrink 0
            text-align right
          .params-item-content
            flex 1
            display flex
            font-size 0.22rem
            flex-wrap wrap
            padding-left 0.1rem
      .radio-item
        letter-spacing 1px
        margin-bottom 0.1rem
        font-size 0.18rem
        margin-right 0.2rem
        input
          width 12px
          height 12px
          cursor pointer
          margin-right 2px
          border-radius 2px
          border solid 1px #e6e6e6
        &.active
          color #f29530
          input
            position relative
            border-color #f29530
            &::after
              content ''
              position absolute
              top -1px
              left 1px
              width 5px
              height 8px
              border-left solid #f29530 1px
              border-top solid #f29530 1px
              transform rotate(225deg)
    .p-list-panel
      flex 1
      overflow hidden
      .p-list
        max-height 100%
        overflow-y auto
        display flex
        justify-content space-between
        flex-wrap wrap
        padding 0 0.4rem 0 0.4rem
        .item
          width 49%
          background #fff
          border-radius 0.05rem
          border 0.01rem solid #eee
          padding 0.25rem
          display flex
          margin-bottom 0.3rem
          font-size 0.16rem
          color #808080
          &:active
            background #f7f7f7
          img
            width 1rem
            margin-right 0.2rem
            object-fit cover
          .name
            font-size 0.24rem
            color #333
            margin 0.15rem 0 0.1rem
      .more-btn
        width 100%
        padding 0 0 0.2rem
        text-align center
        button
          width 2rem
          background #fff
          font-size 0.2rem
          padding 0.1rem
          border-radius 0.1rem
          color #2a69e0
      .empty-info
        text-align center
        color #fff
        width 100%
        padding-top 1rem
        img
          margin-bottom 0.3rem
</style>